import { useState } from "react";
import Joi from "joi";
import { validateFormData } from "../../utils/validation";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { successMsg } from "../../utils/customFn";
import { API_ENDPOINTS } from "../../constants/endPoints";
import BasicProvider from "../../services/basicProvider";

const useForgetPasswordUtils = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token } = useParams();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [formErrors, setFormErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setFormErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const togglePassword = (field) => {
    switch (field) {
      case "new":
        setShowNewPassword(!showNewPassword);
        break;
      case "confirm":
        setShowConfirmPassword(!showConfirmPassword);
        break;
      default:
        break;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationSchema = Joi.object({
      newPassword: Joi.string()
        .min(6)
        .empty("")
        .required()
        .label("New Password")
        .messages({
          "string.empty": "New Password is required.",
          "string.min": "New Password must be at least 6 characters.",
        }),
      confirmPassword: Joi.any()
        .equal(Joi.ref("newPassword"))
        .empty("")
        .required()
        .label("Confirm Password")
        .messages({
          "any.only": "Confirm Password must match New Password.",
          "any.empty": "Confirm Password is required.",
        }),
    });

    const validationResponse = await validateFormData(
      formData,
      validationSchema
    );

    if (!validationResponse.status) {
      setFormErrors(validationResponse.errors);
      return;
    }

    const newFormData = {
      token,
      ...formData,
    };

    try {
      setLoading(true);
      const url = API_ENDPOINTS.reset_password;
      const response = await new BasicProvider(url, navigate, true).postRequest(
        newFormData
      );
      if (response?.status) {
        successMsg(response?.message);
        setFormData({ email: "" });
        navigate("/")
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    formErrors,
    loading,
    handleChange,
    handleSubmit,
    togglePassword,
    showConfirmPassword,
    showNewPassword,
  };
};

export default useForgetPasswordUtils;
